export interface ISelectOption<TValue> {
	value: TValue;
	label: string;
}

export const selectOptionsFrom = <TItem, TValue>(
	items: readonly TItem[],
	mapValue: (i: TItem) => TValue,
	mapLabel: (i: TItem) => string,
): readonly ISelectOption<TValue>[] => {
	return items.map((i) => selectOptionFrom(i, mapValue, mapLabel));
};

export const selectOptionFrom = <TItem, TValue>(
	item: TItem,
	mapValue: (i: TItem) => TValue,
	mapLabel: (i: TItem) => string,
): ISelectOption<TValue> => {
	return selectOption(mapValue(item), mapLabel(item));
};

export const selectOption = <TValue>(
	value: TValue,
	label: string,
): ISelectOption<TValue> => {
	return { value, label };
};
